import { typography } from '@mui/system'
import Header1 from './Header1'
import HeaderGrid from './HeaderGrid'
import Header2 from './Header2'
import { getHeaderData } from 'services/ReduxUtils'

const MainHeader = (props) => {
    const { rows = {} } = props

    const common = {
        textAlign: "center",
        paddingY: '5px',
        paddingX: '10px',
        border: '1px solid #21212166',
        minWidth: '200px'
    }

    const commonStyle = {
        heading: {
            ...common,
            fontSize: "16px",
            fontWeight: '600'
        },
        typography: {
            ...common,
            fontSize: "16px",
        }
    }

    const headerData = getHeaderData()
    const type = headerData?.headerData?.tableName ?? 1

    return (
        (type === "Header 1")
            ? <Header1
                commonStyle={commonStyle}
                data={headerData}
                rows={rows}
            />
            : (type === "Header 2")
                ? <HeaderGrid
                    commonStyle={commonStyle}
                    data={headerData}
                    xs={4}
                    rows={rows}
                />
                : (type === "Header 3")
                    ? <Header1
                        commonStyle={commonStyle}
                        data={headerData}
                        companyHeading={false}
                        rows={rows}
                    />
                    : (type === "Header 4")
                        ? <Header2
                            commonStyle={commonStyle}
                            data={headerData}
                            companyHeading={false}
                            rows={rows}
                        />
                        : (type === "Header 5")
                            ? <HeaderGrid
                                commonStyle={commonStyle}
                                data={headerData}
                                xs={6}
                                rows={rows}
                            /> : null
    )
}

export default MainHeader